module.exports = __webpack_public_path__ + "static/media/brand-logo-white.654f2dd1.svg";